export const advancedPhoneNumberTemplate = (ctx: any) => {
  const id = ctx.id;
  const componentId = `${id}-${ctx.component.key}`;
  const dropdownId = `country-dropdown-${componentId}`;
  const inputId = `phone-input-${componentId}`;
  const extensionInputId = `phone-ext-${componentId}`;
  
  return `
    <div class="phone-number-wrapper" ref="element">
      <div class="phone-number-row">
        <div class="input-group phone-input-group">
          <span class="input-group-prepend">
            <button 
              type="button"
              class="btn btn-default btn-country-selector"
              ref="countryDropdownButton"
              id="${dropdownId}"
              data-dropdown-id="${dropdownId}"
            >
              <span ref="countryFlag" class="country-flag" data-country-code="null">
                <i class="fa fa-globe"></i>
              </span>
              <span ref="countryCode" class="country-code" data-calling-code="null"></span>
              <span class="dropdown-arrow">▼</span>
            </button>
          </span>
          <input
            ref="input"
            type="tel"
            role="textbox"
            class="form-control"
            id="${inputId}"
            name="${ctx.component.key}"
            value="${ctx.getInputDisplayValue()}"
            placeholder="${ctx.component.placeholder || ''}"
            ${ctx.component.disabled ? 'disabled' : ''}
            ${ctx.component.validate?.required ? 'required' : ''}
            autocomplete="tel"
            data-input-id="${inputId}"
          >
        </div>
        ${ctx.component.settings?.useExtension ? `
        <button
          type="button"
          class="btn btn-primary btn-extension-toggle"
          disabled
          ref="extensionToggleButton"
          title="${ctx.t('Extension')}"
        >
          <i class="fa fa-plus"></i> ${ctx.t('Ext.')}
        </button>
        <div class="extension-input-wrapper" ref="extensionWrapper" style="display: none;">
          <input
            ref="extensionInput"
            type="text"
            class="form-control extension-input"
            id="${extensionInputId}"
            placeholder="${ctx.t('Ext.')}"
            ${ctx.component.disabled ? 'disabled' : ''}
            autocomplete="tel-extension"
          >
        </div>
        ` : ''}
      </div>
      <div ref="countryDropdown" class="country-dropdown" data-dropdown-for="${dropdownId}" style="display: none;">
        <div class="country-search">
          <input 
            type="text"
            ref="countryDropdownSearch"
            class="form-control country-search-input" 
            placeholder="${ctx.t('Search countries...')}"
          >
        </div>
        <div class="country-list" ref="countryDropdownList" role="listbox">
          <!-- Countries will be populated by JavaScript -->
        </div>
      </div>
    </div>
  `;
};
